<template>
    <div>
        <div v-if="this.order.type === 'DIL'">
          <div class="titolo-sezioni-cart">{{$t('punto_consegna')}}: <span class="text-uppercase">{{this.zone.traduzione.nome}}</span></div>
            <div class="blocchetto-selezioni">
                <div class="d-flex align-items-center justify-content-start">
                    <label for="delivery-point" class="col-form-label mr-3">
                        <b>{{this.zone.traduzione.label_indirizzo_delivery}}
                            <span class="color">*</span>
                        </b>
                    </label>
                    <div class="flex-grow-1">
                        <input type="text" class="form-control" id="delivery-point" :value="this.delivery_point" @input="updateDeliveryPoint">
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <button type="button" class="btn btn-block" style="padding-left: 0;" @click="show_modal_address = true"
                    :disabled="this.disabled_button_new_address">
                <i class="pi pi-plus f18" v-if="!this.disabled_button_new_address"></i>
                <span class="titolo-sezioni-cart" style="text-transform: initial;">{{$t('carrello_indirizzo_consegna')}}</span>
            </button>
            <div class="blocchetto-selezioni">
                <div v-if="this.selectedAddress === undefined && this.orderAddress">
                    <span>{{this.$t('continuare_indirizzo')}}</span><br/>
                    <span v-if="this.orderAddress">{{this.orderAddress.formatted_address}}</span>
                    <div class="d-flex align-items-center justify-content-between mt-3">
                        <button type="button" class="btn btn-default" @click="handleNoButton">
                            {{this.$t('no')}}
                        </button>
                        <button type="button" class="btn btn-primary" @click="handleYesButton">
                            {{this.$t('yes')}}
                        </button>
                    </div>
                </div>
                <div v-else class="d-flex align-items-center justify-content-between" style="cursor: pointer" @click.prevent="show_modal_select_address = true"
                     v-if="this.addresses.length">
                    <div>
                      <span v-if="this.addresses.length">
                          <span v-if="this.selectedAddress">
                              <span v-if="this.selectedAddress.predefinito">{{$t('carrello_predefinito')}}:<br></span>
                              {{this.selectedAddress.indirizzo}}, {{this.selectedAddress.numero}}<br class="d-md-none">
                              <span v-if="this.selectedAddress.localita_citta">
                                  {{this.selectedAddress.localita_citta}}
                                  <span v-if="this.selectedAddress.cap_citta">
                                      {{this.selectedAddress.cap_citta}}
                                  </span>
                              </span>
                              <span v-if="this.selectedAddress.localita_zona">
                                  - {{$t('zona')}}: {{this.selectedAddress.localita_zona}}
                                  <span v-if="this.selectedAddress.cap_zona">
                                      {{this.selectedAddress.cap_zona}}
                                  </span>
                              </span>
                              <span v-if="this.selectedAddress.provincia">
                                  ({{this.selectedAddress.provincia}})
                              </span>
                          </span>
                          <span v-else>
                              {{$t("carrello_sel_ind_title")}}
                          </span>
                      </span>
                      <span v-else>
                          {{$t('carrello_no_ind_consegna')}}
                      </span>
                    </div>

                    <i class="pi pi-chevron-down"></i>
                </div>
            </div>
        </div>
        <modal-select-address :addresses="this.addresses"
                              :current-address="this.selectedAddress"
                              :order-address="this.orderAddress"
                              :delivery-configuration="this.configurationService"
                              v-if="this.show_modal_select_address"
                              @close="hideModalSelectAddress"/>
        <modal-address v-if="this.show_modal_address"
                       @close="hideModalAddress"
                       :delivery-cities="this.deliveryCities"
                       :delivery-configuration="this.configurationService"
                       :order-address="this.orderAddress"
                       :countries="this.countries"
        />
    </div>
</template>

<script>
import {mapState} from 'vuex';

import ModalSelectAddress from './ModalSelectAddress';
import ModalAddress from '../../account/partials/ModalAddress';

import {equalsInsensitive} from '../../../libraries/utils';
import {newDeliveryAddress} from '../../../api/account';

export default {
    name: "IncDeliveryAddresses",
    components: {ModalAddress, ModalSelectAddress},
    props: ['zone', 'addresses', 'selectedAddress', 'deliveryCities', 'configurationService', 'countries', 'orderAddress'],
    data() {
        return {
            show_modal_select_address: false,
            show_modal_address: false,
            saving: false,
            delivery_point: ''
        }
    },
    computed: {
        disabled_button_new_address: function () {
            return this.selectedAddress === undefined &&
                this.orderAddress &&
                this.orderAddress.tipo === 'COORDINATE'

        },
        ...mapState('restaurant', {
            id_ristorante: state => state.id,
            locale: state => state.locale
        }),
        ...mapState('localization', {
            language: state => state.language
        }),
        ...mapState('auth', {
            user: state => state
        }),
        ...mapState('order', {
            order: state => state
        })
    },
    methods: {
        updateDeliveryPoint: function (e) {
            this.$emit('input', e.target.value);
        },
        hideModalSelectAddress: function (address_id) {
            this.show_modal_select_address = false;

            if (address_id) {
                const address = this.addresses.find((address) => {
                    return address.id === address_id;
                });

                if (address) {
                    this.$emit('onChangeAddress', address);
                }
            }
        },
        hideModalAddress: function (address) {
            if (address) {
                this.$emit('onNewAddress');
            }
            this.show_modal_address = false;
        },
        handleNoButton: function () {
            this.$emit('onClickNoAddress');
        },
        handleYesButton: function () {
            this.saving = true;
            const addressAlreadyExists = this.addresses.filter((address) => {
                const cond1 = address.id_consegna_citta === this.orderAddress.id_consegna_citta;
                const cond2 = this.orderAddress.id_consegna_zona ?
                    address.id_consegna_zona === this.orderAddress.id_consegna_zona : true;
                return cond1 && cond2;
            }).find((address) => {
                let same = true;
                if (!equalsInsensitive(
                    address.indirizzo,
                    this.orderAddress.info.indirizzo,
                )) {
                    same = false;
                }

                if (!equalsInsensitive(
                    address.numero,
                    this.orderAddress.info.numero,
                )) {
                    same = false;
                }

                if (!equalsInsensitive(
                    address.localita_citta,
                    this.orderAddress.info.localita_citta,
                )) {
                    same = false;
                }

                if (!equalsInsensitive(
                    address.cap_citta,
                    this.orderAddress.info.cap_citta,
                )) {
                    same = false;
                }

                if (!equalsInsensitive(
                    address.provincia,
                    this.orderAddress.info.provincia,
                )) {
                    same = false;
                }

                if (!equalsInsensitive(
                    address.nazione,
                    this.orderAddress.info.nazione,
                )) {
                    same = false;
                }

                return same;
            });

            if (addressAlreadyExists) {
                this.saving = false;
                this.$emit('onClickYesAddress', addressAlreadyExists);
            } else {
                newDeliveryAddress(this.language, Object.assign({
                        api_key: this.user.api_key,
                        id_ristorante: this.id_ristorante,
                        tipo: 'COORDINATE',
                        ordine_indirizzo: this.orderAddress,
                    },
                    this.orderAddress.info,
                )).then((response) => {
                    this.$emit('onClickYesAddress', response.indirizzo);
                }).catch((errors) => {
                    alert(errors.join('\n'));
                }).finally(() => {
                    this.saving = false;
                });
            }
        }
    }
}
</script>
